var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9BAEF1",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.404 10.14l4.723 4.722 4.724-4.723M13.127 13.141V1.646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.924 14.54v6.498a.9.9 0 01-.9.9H3.232a.9.9 0 01-.9-.9V14.54"
  }))));
}
export default __webpack_public_path__ + "media/photographerOnboarding/upload-0e930b7c.svg";
export { SvgUpload as ReactComponent };